import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsShipHero() {
  return (
    <IntegrationDocTemplate
      title="ShipHero"
      category="Warehousing · 3PL · WMS"
      status="live"
      summary="ShipHero GraphQL Public API. WMS + shipping software. Owned + operated US warehouse network. Best for brands wanting to operate their own warehouse OR use ShipHero's network."
      prerequisites={[
        'ShipHero account (apply at shiphero.com) — Pro tier or above for API.',
        'Access token from ShipHero settings → API Access.',
        'Familiarity with GraphQL (or just use our adapter which abstracts it).',
      ]}
      connectSteps={[
        'Text us "ShipHero" with your phone number.',
        'Paste your GraphQL access token.',
        'First sync: products + warehouses + recent orders + inventory.',
      ]}
      syncedData={[
        { type: 'Orders', detail: 'order_create mutation; order_cancel mutation; full status tracking' },
        { type: 'Products', detail: 'GraphQL query — variants + warehouse_products per location' },
        { type: 'Inventory', detail: 'On-hand, available, reserved per warehouse' },
        { type: 'Shipments', detail: 'Tracking + carrier + delivery status' },
        { type: 'Returns', detail: 'Return lifecycle with reason codes' },
        { type: 'Transfer orders (May 2026 feature)', detail: 'Move inventory between warehouses' },
      ]}
      agents={[
        { id: 'order_router_agent', name: 'order_router_agent', role: 'Routes orders to ShipHero warehouses' },
        { id: 'cross_channel_inventory_agent', name: 'cross_channel_inventory_agent', role: 'Reserves ShipHero inventory across channels' },
      ]}
      troubleshooting={[
        { question: 'GraphQL rate limit', answer: 'ShipHero uses query complexity scoring. Our adapter chunks large queries automatically.' },
        { question: 'Replenishment levels', answer: 'ShipHero sets replenishment_level per warehouse. We do not auto-modify these — set them in ShipHero UI.' },
      ]}
      supportLink="/contact"
    />
  );
}
